/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { MxCallFragmentDoc } from '../../mx-calls/MxCallListItem.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmCompanyMxCallsBoxQueryVariables = Types.Exact<{
  crmCompanyId: Types.Scalars['ID']['input'];
}>;


export type CrmCompanyMxCallsBoxQuery = { mxCalls: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'MxCallsConnection', totalCount: number, edges: Array<{ __typename: 'MxCallEdge', node: { __typename: 'MxCall', id: string, incomingNumber: string, outgoingNumber: string, isProcessed: boolean, startTime: any, endTime: any, type?: Types.MxCallType | null, status?: Types.MxCallStatus | null, source?: Types.MxCallSource | null, crmCompany?: { __typename: 'CrmCompany', id: string, title: string, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string } | null } | null, category?: { __typename: 'Category', id: string, name: string } | null } }> } };


export const CrmCompanyMxCallsBoxDocument = gql`
    query CrmCompanyMxCallsBox($crmCompanyId: ID!) {
  mxCalls(
    filters: {crmOrganisationId: $crmCompanyId}
    limit: 10
    sorting: [{column: startTime, direction: desc}]
  ) {
    ... on MxCallsConnection {
      edges {
        node {
          ...MxCall
        }
      }
      totalCount
    }
  }
}
    ${MxCallFragmentDoc}`;

/**
 * __useCrmCompanyMxCallsBoxQuery__
 *
 * To run a query within a React component, call `useCrmCompanyMxCallsBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmCompanyMxCallsBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmCompanyMxCallsBoxQuery({
 *   variables: {
 *      crmCompanyId: // value for 'crmCompanyId'
 *   },
 * });
 */
export function useCrmCompanyMxCallsBoxQuery(baseOptions: Apollo.QueryHookOptions<CrmCompanyMxCallsBoxQuery, CrmCompanyMxCallsBoxQueryVariables> & ({ variables: CrmCompanyMxCallsBoxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmCompanyMxCallsBoxQuery, CrmCompanyMxCallsBoxQueryVariables>(CrmCompanyMxCallsBoxDocument, options);
      }
export function useCrmCompanyMxCallsBoxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmCompanyMxCallsBoxQuery, CrmCompanyMxCallsBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmCompanyMxCallsBoxQuery, CrmCompanyMxCallsBoxQueryVariables>(CrmCompanyMxCallsBoxDocument, options);
        }
export function useCrmCompanyMxCallsBoxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrmCompanyMxCallsBoxQuery, CrmCompanyMxCallsBoxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrmCompanyMxCallsBoxQuery, CrmCompanyMxCallsBoxQueryVariables>(CrmCompanyMxCallsBoxDocument, options);
        }
export type CrmCompanyMxCallsBoxQueryHookResult = ReturnType<typeof useCrmCompanyMxCallsBoxQuery>;
export type CrmCompanyMxCallsBoxLazyQueryHookResult = ReturnType<typeof useCrmCompanyMxCallsBoxLazyQuery>;
export type CrmCompanyMxCallsBoxSuspenseQueryHookResult = ReturnType<typeof useCrmCompanyMxCallsBoxSuspenseQuery>;
export type CrmCompanyMxCallsBoxQueryResult = Apollo.QueryResult<CrmCompanyMxCallsBoxQuery, CrmCompanyMxCallsBoxQueryVariables>;